import * as React from "react";
import "./style.css";
import config from '../../config'
import {useSelector} from "react-redux";
import {dictionary} from "../../constants"

const Footer = () => {

const { language , direction } = useSelector(state => state.home);

    const openLinkedin = () => {
        window.open("linkedin://profile/company/Phoenix Baziigram");
    };
    const openInsta = () => {
        window.open("instagram://user?username=baziigram");
    };
    const callNumber = () => {
        window.open("tel:02171057799");
    };

    return (
        <div className={`footer flex-row ${direction} ${direction=="rtl" ? "text-right" :"text-left"}`}>
        <div className="flex-column align-items-start">
                   <div className="mb-3"><a href="/AboutUs">{dictionary.aboutUs[language]}</a></div>
                    <div><a className="mt-3" href="https://developers.baziigram.com" target="https://developers.baziigram.com" >{dictionary.developers[language]}</a></div>
                    </div>

                <div className={"text-center"}>{config.app.version}</div>


            <div className="connect">
               {/*<p>راه های ارتباط با ما</p>*/}
                <div className="icons">
                    <div
                        className={
                            "d-flex flex-row justify-content-end align-items-center"
                        }
                    >
                        <img
                            className={"mx-2"}
                            onClick={openInsta}
                            src="/images/icons/ic_instagram.png"
                            title="instagram"
                        />

                        {/*<img
                            className={"mx-2"}
                            onClick={openLinkedin}
                            src="/images/icons/ic_linkdin.png"
                            title="linkdin"
                        />*/}
                        {/*<div className={"mx-2"} onClick={callNumber}>
                           021-71057799
                       </div>*/}
                    </div>
                </div>
            </div>


        </div>
    );
};

export default Footer;
